// locale-unextracted-ignore-file
import { Debug } from '@app/components/base/Debug';
import { useTimezone } from '@app/core/hooks';
import { Box } from '@mui/material';
import { DateTime } from 'luxon';
import { useStreamUserDefinedRange } from '../stores/stream-screen.store';

export function StreamDebug() {
  const { from, to } = useStreamUserDefinedRange();
  const tz = useTimezone();

  return (
    <Debug>
      <Box mt={1} mb={0.5}>
        {DateTime.fromMillis(from, { zone: tz }).toString()} &nbsp;-&nbsp;
        {DateTime.fromMillis(to, { zone: tz }).toString()} &nbsp; {tz}
      </Box>
      <Box>
        {new Date(from).toISOString()} &nbsp;-&nbsp; {new Date(to).toISOString()}
      </Box>
    </Debug>
  );
}
